import LANGUAGES, { type LanguageCode } from './Languages';

const LANGUAGE_CODES = Object.keys(LANGUAGES) as LanguageCode[];

export default LANGUAGE_CODES;
